/**
 * Zoom controls for the banner editor canvas
 */
import { Button } from "@/components/ui/button";
import { ZoomIn, ZoomOut, Maximize2 } from "lucide-react";

export function ZoomControls({ zoom, setZoom }) {
  return (
    <div className="flex items-center justify-center gap-2 py-2 bg-[#12121a] border-b border-white/5">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setZoom(Math.max(25, zoom - 25))}
        className="h-7 px-2 text-gray-400 hover:text-white"
        data-testid="zoom-out-btn"
      >
        <ZoomOut className="w-4 h-4" />
      </Button>
      <span className="text-xs text-gray-400 w-12 text-center">{zoom}%</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setZoom(Math.min(200, zoom + 25))}
        className="h-7 px-2 text-gray-400 hover:text-white"
        data-testid="zoom-in-btn"
      >
        <ZoomIn className="w-4 h-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setZoom(100)}
        className="h-7 px-2 text-gray-400 hover:text-white"
        data-testid="zoom-fit-btn"
      >
        <Maximize2 className="w-4 h-4" />
      </Button>
    </div>
  );
}
